import(/* webpackMode: "eager", webpackExports: ["AuthProvider","JotaiProvider"] */ "/codebuild/output/src36880211/src/apps/fanychance/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src36880211/src/apps/fanychance/src/components/library/TagManager/TagManager.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src36880211/src/apps/fanychance/src/styles/global.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src36880211/src/apps/fanychance/src/styles/reset.scss");
